import type { FaireProductEntity } from "../../entity_types/product";

export const p_835fhjc86p: FaireProductEntity = {
  token: "p_835fhjc86p",
  type: "product",
  name: "Teakwood & Tobacco - 12.5 oz Large Concentrated Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/d36a2934c980de25e987664189b0fc211a81e41d5f6114f8de191c9a5ee58f0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29c146262ff82b9977b27eb0a2d3d7b1d58ffe1e6cfba95f1f79b0fbf9d82304.jpeg",
    "https://cdn.faire.com/fastly/ba946a3b29a28d2998a53d402492d4dc8007d55ceb1fad5fa45fee3853bbbd9f.jpeg",
    "https://cdn.faire.com/fastly/c75ddc30e2043b700d95e82be4d74b36b41c02b52d421524fd201b3eb4f1727c.jpeg",
    "https://cdn.faire.com/fastly/50b5b08c849b051898bd3484181d6b4a1887fbfffe7bf2945c37e06eaffe04e8.png",
    "https://cdn.faire.com/fastly/afbe679981c3d3e032816803c911acc1445fb493b8af6041a885784071de9717.jpeg",
    "https://cdn.faire.com/fastly/2c0513b366ce92444a1ba54c40ea2665868f10ed7e7aa4b35faecbd9760f7e3f.jpeg",
  ],
  priceDollars: 18,
  description:
    "The one that started it all. Some call it the boyfriend scent, we call it the O.G. Notes of leather, teak, and orange.\n\nIntroducing our new and reformulated Large Concentrated Candles – we took our best-selling Classic Line scents and increased the fragrance level for stronger throw in your biggest spaces.\n\nOur 12.5 oz Large Candles are hand-poured into apothecary-inspired amber jars with our signature kraft label and a brass lid. \n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 60-70 hours.",
  tags: [],
  msrpDollars: 37.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:46.314Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
